import { isString } from "../utils/primitives";
import { getWindow } from "../utils/window";

/*
 * Send tracking event to Segment.
 *
 * Accepts either an object populated with the specific arguments to
 * pass to Segment, or four individual arguments: the event name, a
 * properties object, an options object, and a callback.
 *
 * Example 1: Calling with direct arguments
 *
 *  track('Business Created', { businessName: "Bob's Burgers" })
 *
 * Example 2: Calling with an object
 *
 *  track({
 *    event: 'businessCreated',
 *    properties: { businessName: "Bob's Burgers" }
 *  })
 *
 */
export function trackToSegment(...args) {
  try {
    const { event, properties, options, callback } = processArgs(args, "event");
    if (shouldSendEvent()) {
      console.debug("Sending event to Segment: ", event, properties);
      getWindow().analytics.track(event, properties, options, callback);
    } else {
      console.debug("[SKIP] Sending event to Segment: ", event, properties);
    }
    return {
      event,
      properties,
    };
  } catch (e) {
    console.error(e);
  }
}

/*
 * The same as "track", but specifies an event of "userId".
 */
export function identifyToSegment(...args) {
  try {
    const { userId, properties, options, callback } = processArgs(args, "userId");
    if (shouldSendEvent()) {
      console.debug("Sending user identity to Segment: ", userId, properties);
      getWindow().analytics.identify(userId, properties, options, callback);
    } else {
      console.debug("[SKIP] Sending user identity to Segment: ", userId, properties);
    }
    return {
      event: "Identify",
      userId,
      properties,
    };
  } catch (e) {
    console.error(e);
  }
}

export function pageToSegment(...args) {
  try {
    const { name, properties, options, callback } = processArgs(args, "name");
    if (shouldSendEvent()) {
      console.debug("Sending page load to Segment: ", name, properties);
      getWindow().analytics.page(name, properties, options, callback);
    } else {
      console.debug("[SKIP] Sending page load to Segment: ", name, properties);
    }
    return {
      event: "Page Load",
      name,
      properties,
    };
  } catch (e) {
    console.error(e);
  }
}

export function shouldSendEvent() {
  return !!getWindow().analytics;
}

function processArgs(args, eventName) {
  if (args.length === 1 && !isString(args[0])) {
    return args[0];
  }
  return {
    [eventName]: args[0],
    properties: args[1],
    options: args[2],
    callback: args[3],
  };
}
